import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { LabelService } from 'src/app/shared/services/label.service';


@Component({
  standalone: false,
  selector: 'app-study-saved',
  templateUrl: './study-saved.component.html',
  styleUrls: ['./study-saved.component.scss']
})
export class StudySavedComponent {
  @Output() overlayClosed = new EventEmitter<void>()
  i18n = this.labelService.labels
  constructor(private readonly labelService: LabelService, private readonly router : Router){}

  studySaved() {
    this.overlayClosed.emit()
  }
}
